import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import { useResizeDetector } from "react-resize-detector";
// import VideoSection from "../Videocarousel/DeskExperience";
// import VideoSection from "../VideoSection/ExploreSection";


import "./RecaptureTheMoments.css";

export default function RecaptureTheMoments() {
    const imgCDNURL = process.env.REACT_APP_ANGELAI_IMAGES;

    const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleThumbnails, setVisibleThumbnails] = useState([]);
  const [touchStartX, setTouchStartX] = useState(null);
  const { width, ref } = useResizeDetector();
  const [play, setPlay] = useState(false);
  const [url, setUrl] = useState("");
  const videoToggle = (play, url) => {
    setPlay(!play);
    setUrl(url);
  };

  let device;
  if (width < 768) {
    device = "mobile";
  } else if (width < 992) {
    device = "tablet";
  } else if (width < 2001) {
    device = "desktop";
  } else {
    device = "superLargeDesktop";
  }

  useEffect(() => {
    // Fetch images from the JSON file using axios
    axios
      .get(process.env.REACT_APP_POSTCHICAGOMO_CDN_URL + "RecaptureTheMoments.json")
      .then((response) => {
        setImages(response.data);
        setSelectedImage(response.data[0]);
        setVisibleThumbnails(response.data.slice(0, 5));
      })
      .catch((error) => {
        console.error("Error fetching images:", error);
      });
  }, []);

  const selectImage = (index) => {
    setSelectedImage(images[index]);
    setCurrentIndex(index);
    updateVisibleThumbnails(index);
  };

  const updateVisibleThumbnails = (startIndex) => {
    const currentSlideIndex = Math.floor(startIndex / 5);
    const startIndexInSlide = startIndex % 5;
    const startThumbnailIndex = currentSlideIndex * 5;

    // Calculate the indices of the thumbnails to be displayed based on the current slide.
    const newVisibleThumbnails = images.slice(startThumbnailIndex, startThumbnailIndex + 5);

    setVisibleThumbnails(newVisibleThumbnails);
  };

  const handleTouchStart = (event) => {
    setTouchStartX(event.touches[0].clientX);
  };

  const handleTouchEnd = (event) => {
    if (touchStartX !== null) {
      const touchEndX = event.changedTouches[0].clientX;
      const touchDifference = touchEndX - touchStartX;
      if (touchDifference > 50) {
        // Swipe right
        prevImage();
      } else if (touchDifference < -50) {
        // Swipe left
        nextImage();
      }
      setTouchStartX(null);
    }
  };


  const nextImage = () => {
    const currentBatchStartIndex = Math.floor(currentIndex / 5) * 5;
    let nextIndex = currentIndex + 1;

    if (nextIndex >= images.length) {
      // If nextIndex exceeds the total number of images, wrap around to the first image.
      nextIndex = 0;
    }

    if (nextIndex % 4 === 0) {
      // If the next image is the first image of the next slide, update visible thumbnails accordingly.
      const nextBatchStartIndex = Math.floor(nextIndex / 5) * 5;
      updateVisibleThumbnails(nextBatchStartIndex);
    }

    selectImage(nextIndex);
  };



  const prevImage = () => {
    const currentBatchStartIndex = Math.floor(currentIndex / 5) * 5;
    let prevIndex = currentIndex - 1;

    if (prevIndex < 0) {
      // If prevIndex is negative, wrap around to the lastimage of the previous slide.
      prevIndex = images.length - 1;
    }

    if ((prevIndex + 1) % 5 === 0) {
      // If the previous image was the first image of the current slide, update visible thumbnails accordingly.
      const prevBatchStartIndex = Math.floor(prevIndex / 5) * 5;
      updateVisibleThumbnails(prevBatchStartIndex);
    }

    selectImage(prevIndex);
  };

    return (
        <div>
            <Container className="coaching-container">
          <h3 className="coachingheading">Recapture The Moments</h3>
<Row>
  
  <Col xl={12} lg={12} md={12} sm={12} xs={12}>
  
          <div className="carousel-container" onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}>
            {selectedImage && (
              <img
                className="main-image"
                src={selectedImage.imgPath}
                onClick={() => videoToggle(play, selectedImage.url)}
                alt="Center Image"
              />
            )}
          </div>
          <div className="thumbnail-container">
          <div onClick={prevImage} className="previous">
             {"<"} 
            </div>
            {visibleThumbnails.map((image, index) => (
              <img
                key={index}
                className={`thumbnail ${currentIndex % 5 === index ? "active" : ""
                  }`}
                src={image.imgPath}
                alt="Images"
                onClick={() =>
                  selectImage(currentIndex - (currentIndex % 5) + index)
                }
              />
            ))}
            <div onClick={nextImage} className="next">
             {">"} 
            </div>
          </div>
          </Col>
          </Row>
        </Container>
        </div>
    )
}
